import React from "react";

import { bdtFmt } from "./InvestorTxnDetailUi";
import { formatShareQty } from "../../utils/investorRedeemEligibility";

/**
 * Post-submit confirmation for an outgoing NAV-locked transfer offer.
 */
export default function TransferRequestConfirmPanel({ data, projectLabel, onDone }) {
  const ref = data?.transfer_ref;
  const shares = data?.shares != null ? formatShareQty(data.shares) : null;
  const recipient = data?.transfer_recipient_display || "the recipient";
  const lockedNav = Number(data?.price_per_share || 0);
  const gross =
    data?.transfer_gross_bdt != null
      ? Number(data.transfer_gross_bdt)
      : lockedNav > 0 && shares
        ? lockedNav * Number(data.shares)
        : null;

  return (
    <div className="investor-offer-detail__reject-success" role="status">
      <p className="msg msg-success" style={{ margin: 0 }}>
        Your transfer offer has been <strong>submitted</strong>.
        {ref ? (
          <>
            {" "}
            Reference <strong>{ref}</strong>.
          </>
        ) : null}
      </p>
      <ul className="investor-transfer-confirm__facts muted">
        {projectLabel ? (
          <li>
            <strong>Project:</strong> {projectLabel}
          </li>
        ) : null}
        {shares ? (
          <li>
            <strong>Shares offered:</strong> {shares}
          </li>
        ) : null}
        <li>
          <strong>To:</strong> {recipient}
        </li>
        {lockedNav > 0 ? (
          <li>
            <strong>Locked NAV / share:</strong> {bdtFmt.format(lockedNav)}
          </li>
        ) : null}
        {gross != null && gross > 0 ? (
          <li>
            <strong>Offer value (gross):</strong> {bdtFmt.format(gross)}
          </li>
        ) : null}
      </ul>
      <p className="investor-offer-detail__hint muted" style={{ marginTop: "0.5rem" }}>
        The recipient must accept at this locked NAV before settlement. Your shares stay in your account until the offer
        is accepted, rejected, or cancelled. No wallet payment is taken from you at submit time.
      </p>
      <div className="investor-offer-detail__footer" style={{ marginTop: "0.75rem", paddingTop: "0.65rem" }}>
        <button type="button" className="invx-trade-submit compact-btn" onClick={onDone}>
          Done
        </button>
      </div>
    </div>
  );
}
